<template>
  <v-row
    no-gutters
    align="center"
    justify="center"
    class="deltia-card ml-2 mr-2 mb-5 pl-6 pr-6 pt-6 pb-5"
  >
    <!-- Descripción de cada campo -->
    <v-col cols="12" class="hidden-sm-and-down">
      <v-row no-gutters>
        <!-- Columna para el nombre -->
        <v-col cols="12" md="5">
          <p class="font-weight-medium mb-1 text--disabled">
            Nombre
          </p>
        </v-col>
        <!-- Tipo de usuario -->
        <v-col cols="12" md="2">
          <p class="font-weight-medium mb-1 text--disabled">
            Tipo
          </p>
        </v-col>
        <!-- Columna para el número de teléfono -->
        <v-col cols="12" md="3">
          <p class="font-weight-medium mb-1 text--disabled">
            Número de teléfono
          </p>
        </v-col>
        <!-- Columna para la fecha -->
        <v-col
          cols="12"
          md="2"
          :class="{ 'text-right': $vuetify.breakpoint.mdAndUp }"
        >
          <p class="font-weight-medium mb-1 text--disabled">
            Fecha
          </p>
        </v-col>
      </v-row>
    </v-col>
    <!-- Columna para el nombre -->
    <v-col cols="12" md="5">
      <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
        Nombre
      </p>
      <p class="content--text font-weight-medium mb-0">
        {{ name }}
      </p>
    </v-col>
    <!-- Tipo de usuario -->
    <v-col cols="12" md="2">
      <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
        Tipo
      </p>
      <p
        class="content--text font-weight-medium mb-0"
        v-if="type == 'employee'"
      >
        Empleado
      </p>
    </v-col>
    <!-- Columna para el número de teléfono -->
    <v-col cols="12" md="3">
      <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
        Número de teléfono
      </p>
      <p class="content--text font-weight-medium mb-0">
        {{ phoneNumber }}
      </p>
    </v-col>
    <!-- Columna para la fecha -->
    <v-col
      cols="12"
      md="2"
      :class="{ 'text-right': $vuetify.breakpoint.mdAndUp }"
    >
      <p class="font-weight-medium mb-1 text--disabled hidden-md-and-up">
        Fecha
      </p>
      <p class="content--text font-weight-medium mb-0">
        {{ formatDate(date) }}
      </p>
    </v-col>
    <!-- Descripción las opciones -->
    <v-col cols="12">
      <v-row no-gutters>
        <!-- Columna para la fecha -->
        <v-col cols="12" class="text-right">
          <p class="font-weight-medium mt-3 mb-1 text--disabled">
            Opciones
          </p>
        </v-col>
      </v-row>
    </v-col>
    <!-- Columna para los ajustes -->
    <v-col cols="12" class="text-right">
      <v-btn
        @click="
          $router.push({ name: 'employee-details', params: { id: userId } })
        "
        text
        color="secondary"
        class="pa-0"
      >
        Ver ajustes <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
// Importar mixins
import dateFormat from "@/mixins/dateFormat.js";

export default {
  name: "UserItem",
  mixins: [dateFormat],
  data() {
    return {
      dialog: false,
      menu: false,
      secondMenu: false
    };
  },
  props: {
    userId: {
      type: String
    },
    date: {
      type: String
    },
    type: {
      type: String
    },
    name: {
      type: String
    },
    phoneNumber: {
      type: String
    }
  },
  methods: {
    alert: function() {
      this.dialog = true;
    },
    updateUser() {
      this.$emit("update-user");
    },
    deleteUser() {
      this.$emit("delete-user");
    },
    employeeError(message) {
      this.$emit("employee-error", message);
    }
  }
};
</script>
